import type { AgentRole } from '@/types/agent';
import type { EventType } from '@/types/event';

export const AGENT_COLORS: Record<string, string> = {
  atlas: '#FFD700',
  nova: '#E040FB',
  cipher: '#00E5FF',
  forge: '#FF6D00',
  echo: '#00E676',
  halo: '#2979FF',
  prism: '#7C4DFF',
  vector: '#FFB300',
  argus: '#FF1744',
};

export const ROLE_COLORS: Record<AgentRole, string> = {
  director: '#FFD700',
  cmo: '#E040FB',
  seo: '#00E5FF',
  catalogue: '#FF6D00',
  communication: '#00E676',
  sav: '#2979FF',
  data: '#7C4DFF',
  marketplace: '#FFB300',
  qa: '#FF1744',
};

export const STATUS_COLORS: Record<string, string> = {
  idle: '#4a5568',
  working: '#00E676',
  moving: '#00E5FF',
  thinking: '#E040FB',
  waiting_validation: '#FFB300',
  offline: '#2d3748',
  error: '#FF1744',
  meeting: '#7C4DFF',
};

export const EVENT_COLORS: Record<EventType, string> = {
  publication: '#00E676',
  validation_needed: '#FFB300',
  sale: '#FFD700',
  alert: '#FF1744',
  task_done: '#00E5FF',
  agent_moved: '#4a5568',
  error: '#FF1744',
  meeting: '#7C4DFF',
  collaboration: '#E040FB',
  system: '#4a5568',
  seo: '#00E5FF',
  customer: '#2979FF',
};

export const EVENT_ICONS: Record<EventType, string> = {
  publication: '📄',
  validation_needed: '⚠',
  sale: '💰',
  alert: '🔴',
  task_done: '✓',
  agent_moved: '→',
  error: '✗',
  meeting: '◆',
  collaboration: '⬡',
  system: '⚙',
  seo: '◎',
  customer: '◉',
};

/** Converts a hex color string to a Pixi-compatible number */
export function hexToNum(hex: string): number {
  return parseInt(hex.replace('#', ''), 16);
}

/** Darkens a hex color by a factor (0-1) */
export function darken(hex: string, factor: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `#${Math.round(r * (1 - factor)).toString(16).padStart(2, '0')}${Math.round(g * (1 - factor)).toString(16).padStart(2, '0')}${Math.round(b * (1 - factor)).toString(16).padStart(2, '0')}`;
}

/** Returns a semi-transparent version of a hex color */
export function withAlpha(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}
